module.exports = __webpack_public_path__ + "img/img-icon-yesdok.f5b8880.png";